/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export const DOMAIN_NAME_EMAIL = 'userinterviews.com'

export const ADDRESSES = {
  
    'BILLING_EMAIL': 'billing@userinterviews.com',
  
    'COMPENSATION_EMAIL': 'compensation@userinterviews.com',
  
    'NOTIFY_EMAIL': 'notify@userinterviews.com',
  
    'PLANS_EMAIL': 'plans@userinterviews.com',
  
    'PROJECTS_EMAIL': 'projects@userinterviews.com',
  
    'RESEARCH_EMAIL': 'research@userinterviews.com',
  
    'SALES_EMAIL': 'sales@userinterviews.com',
  
    'SCHEDULE_EMAIL': 'schedule@userinterviews.com',
  
    'SUPPORT_EMAIL': 'support@userinterviews.com',
  
    'PARTICIPANT_SUPPORT_EMAIL': 'support@userinterviews.com',
  
    'RESEARCHER_SUPPORT_EMAIL': 'projects@userinterviews.com',
  
    'TECH_SUPPORT_EMAIL': 'techsupport@userinterviews.com',
  
    'STRATEGY_EMAIL': 'strategy@userinterviews.com',
  
} as const;

export const VALID_DEPARTMENTS = ["PLANS"] as const;

export const DEPARTMENTS = {
  
    'PLANS': 'PLANS',
  
} as const;

export const DEFAULT_FROM_NAME = 'User Interviews' as const;

export const PURPOSES = {
  
    'participant_invitation': 'participant_invitation',
  
    'participant_invitation_reminder': 'participant_invitation_reminder',
  
    'participant_new_message': 'participant_new_message',
  
    'participant_approval': 'participant_approval',
  
    'participant_unmoderated_approval': 'participant_unmoderated_approval',
  
    'participant_unscheduled': 'participant_unscheduled',
  
    'participant_sessions_available': 'participant_sessions_available',
  
    'participant_session_confirmed': 'participant_session_confirmed',
  
    'participant_session_reschedule_request': 'participant_session_reschedule_request',
  
    'participant_session_canceled': 'participant_session_canceled',
  
    'participant_session_reminder': 'participant_session_reminder',
  
    'participant_slot_opened': 'participant_slot_opened',
  
    'participant_incentive_distributed': 'participant_incentive_distributed',
  
    'participant_incentive_payment': 'participant_incentive_payment',
  
    'participant_thank_you': 'participant_thank_you',
  
} as const;

export const PARTICIPANT_EMAIL_CLASSES = ["Emails::Participants::ApprovedForProjectPostmarkCustomEmail","Emails::Participants::ApprovedForProjectMandrillCustomEmail","Emails::Participants::ParticipantUnscheduledPostmarkCustomEmail","Emails::Participants::ParticipantUnscheduledMandrillCustomEmail","Emails::Participants::IncentiveDistributedPostmarkCustomEmail","Emails::Participants::IncentiveDistributedMandrillCustomEmail","Emails::Participants::IncentivePaymentPostmarkCustomEmail","Emails::Participants::IncentivePaymentMandrillCustomEmail","Emails::Participants::ProjectInvitationPostmarkCustomEmail","Emails::Participants::ProjectInvitationMandrillCustomEmail","Emails::Participants::ProjectInvitationReminderPostmarkCustomEmail","Emails::Participants::ProjectInvitationReminderMandrillCustomEmail","Emails::Participants::ResearcherMessagePostmarkCustomEmail","Emails::Participants::ResearcherMessageMandrillCustomEmail","Emails::Participants::SessionConfirmationPostmarkCustomEmail","Emails::Participants::SessionConfirmationMandrillCustomEmail","Emails::Participants::SessionReminderPostmarkCustomEmail","Emails::Participants::SessionReminderMandrillCustomEmail","Emails::Participants::SlotOpenedPostmarkCustomEmail","Emails::Participants::SlotOpenedMandrillCustomEmail","Emails::Participants::ParticipantThankYouPostmarkCustomEmail","Emails::Participants::ParticipantThankYouMandrillCustomEmail","Emails::Participants::ApprovedForProjectMandrillEmail","Emails::Participants::ApprovedForUnmoderatedProjectMandrillEmail","Emails::Participants::IncentiveDistributedMandrillEmail","Emails::Participants::IncentivePaymentMandrillEmail","Emails::Participants::ResearcherMessageMandrillEmail","Emails::Participants::SessionConfirmationMandrillEmail","Emails::Participants::SessionReminderMandrillEmail","Emails::Participants::SlotOpenedEmail"]

export const PARTICIPANT_FOOTER_URL = 'https://www.userinterviews.com?utm_source=postmark%26utm_medium=email%26utm_campaign=P-Hub-emails'

export const UI_LOGO_NAVY_BG_IMG_PATH = '/images/ui-logo-navy-bg.svg'
export const UI_LOGO_IMG_PATH = '/images/ui-logo.svg'

export const TeamLogoHandlebarMatcher = new RegExp(/{{\s*team_logo_url\s*}}/, 'g');
